export default {
      id: "truckIcon-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "icons.svg#truckIcon",
      toString: function () {
        return this.url;
      }
    }